import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { WebSocketSubject } from 'rxjs/internal-compatibility';
import { retry } from 'rxjs/operators';

export interface TimeTableProgressData {
  id: string;
  route: string;
  filename: string;
  started: boolean;
  progress?: number;
  completed: boolean;
}
@Injectable({
  providedIn: 'root',
})
export class ProgressTimetableService {
  socket$: WebSocketSubject<any>;
  uploadData: TimeTableProgressData[] = [
    // {
    //   id: '1',
    //   route: '124',
    //   filename: 'test.csv',
    //   started: true,
    //   completed: false,
    // },
    // {
    //   id: '2',
    //   route: '126',
    //   filename: 'test3.csv',
    //   started: true,
    //   completed: true,
    // },
    // {
    //   id: '3',
    //   route: '125',
    //   filename: 'test2.csv',
    //   started: false,
    //   completed: false,
    // },
  ];

  constructor(private httpClient: HttpClient) {}

  get list() {
    return this.uploadData;
  }

  get length() {
    return this.uploadData.length;
  }

  get completed() {
    return this.uploadData.filter(item => item?.completed).length;
  }

  add(id: string, route: string, filename: string) {
    const newItem: TimeTableProgressData = {
      id,
      filename,
      route,
      started: false,
      completed: true,
      // completed: false,
    };
    this.uploadData.push(newItem);
  }

  listen() {
    const urlAction = '';
    this.socket$ = new WebSocketSubject(urlAction);

    this.socket$.pipe(retry()).subscribe(data => {
      console.log(data);
    });
  }

  send(id: string, data) {
    const msgData = {
      id,
      ...data,
    };
    this.socket$.next(msgData);
  }

  remove(id: string) {
    console.log('id', id);
    this.uploadData = this.uploadData.filter(data => data.id !== id);
  }

  clear() {
    this.uploadData = [];
  }

  stop() {
    this.socket$?.unsubscribe();
    this.socket$ = undefined;
  }
}
